<div class="calendar-header">
    <button type="button" class="calendar-header__nav" (click)="prev()">
        <span class="icon-left"></span>
    </button>
    <span class="callout-1">{{ periodLabel }}</span>
    <button type="button" class="calendar-header__nav" (click)="next()">
        <span class="icon-right"></span>
    </button>
</div>
